import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=5456b99c&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=ts"
export * from "./Notifications.vue?vue&type=script&lang=ts"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=5456b99c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456b99c",
  null
  
)

export default component.exports